import { Skeleton } from '@growtherapy/sprout-ui';

import { ProviderAvatar, ProviderAvatarProps } from './ProviderAvatar';
import { useGetCurrentProviderQuery } from './useGetCurrentProviderQuery';

export function ProviderAvatarWrapper(props: Partial<ProviderAvatarProps>) {
  const { data, loading } = useGetCurrentProviderQuery();

  if (loading || !data) {
    return (
      <div className='flex gap-3 items-center'>
        <Skeleton className='my-0 mx-0 rounded-full w-18 h-18' />
        <Skeleton className='my-0 mx-0 w-28' />
      </div>
    );
  }

  return <ProviderAvatar provider={data.currentProvider} {...props} />;
}
